import { useEffect, useState } from 'react';
export var useWindowDimensions = function () {
    var height = window.innerHeight || 0;
    var width = window.innerWidth || 0;
    var _a = useState({ height: height, width: width }), dimensions = _a[0], setDimensions = _a[1];
    useEffect(function () {
        var dimensionHandler = function () {
            setDimensions({
                height: window.innerHeight || 0,
                width: window.innerWidth || 0,
            });
        };
        window.addEventListener('resize', dimensionHandler);
        return function () {
            window.removeEventListener('resize', dimensionHandler);
        };
    }, []);
    return dimensions;
};
